import React, { useEffect, useState } from 'react';
import { API_BASE } from '../lib/config';

const API = `${API_BASE}`;

const Row = ({ e }) => (
  <tr className="border-t">
    <td className="px-4 py-2 text-sm">{new Date(e.created_at).toLocaleString()}</td>
    <td className="px-4 py-2 text-sm">{e.direction === 'credit' ? '+' : '-'}¥{Number(e.amount).toFixed(2)}</td>
    <td className="px-4 py-2 text-sm">{e.category}</td>
    <td className="px-4 py-2 text-sm">{e.description || '-'}</td>
    <td className="px-4 py-2 text-sm">{e.ref_type || '-'}</td>
    <td className="px-4 py-2 text-sm truncate">{e.ref_id || '-'}</td>
  </tr>
);

const UserLedgerPage = () => {
  const [ledger, setLedger] = useState({ items: [], balance: 0 });
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;

  const fetchAll = async () => {
    try {
      setLoading(true);
      const [lres, eres] = await Promise.all([
        fetch(`${API}/ledger/my`, { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API}/payments/my-events`, { headers: { Authorization: `Bearer ${token}` } }),
      ]);
      const l = lres.ok ? await lres.json() : { items: [], balance: 0 };
      const ev = eres.ok ? await eres.json() : [];
      setLedger(l);
      setEvents(Array.isArray(ev) ? ev : []);
    } catch (_) {
      setLedger({ items: [], balance: 0 });
      setEvents([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchAll(); }, []);

  return (
    <div className="max-w-5xl mx-auto p-4">
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900">ウォレット・履歴</h1>
        <div className="text-sm text-gray-700">残高: <span className="font-semibold">¥{Number(ledger.balance).toFixed(2)}</span></div>
      </div>

      <div className="bg-white rounded-lg shadow mb-6">
        <div className="p-4 border-b font-semibold">台帳</div>
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 text-left text-sm text-gray-500">日時</th>
                <th className="px-4 py-2 text-left text-sm text-gray-500">金額</th>
                <th className="px-4 py-2 text-left text-sm text-gray-500">区分</th>
                <th className="px-4 py-2 text-left text-sm text-gray-500">説明</th>
                <th className="px-4 py-2 text-left text-sm text-gray-500">参照タイプ</th>
                <th className="px-4 py-2 text-left text-sm text-gray-500">参照ID</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={6} className="px-4 py-6 text-center text-gray-500">読み込み中...</td></tr>
              ) : ledger.items.length === 0 ? (
                <tr><td colSpan={6} className="px-4 py-6 text-center text-gray-500">記録がありません</td></tr>
              ) : (
                ledger.items.map((e) => <Row key={e.id} e={e} />)
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow">
        <div className="p-4 border-b font-semibold">決済イベント</div>
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 text-left text-sm text-gray-500">日時</th>
                <th className="px-4 py-2 text-left text-sm text-gray-500">タイプ</th>
                <th className="px-4 py-2 text-left text-sm text-gray-500">ID</th>
              </tr>
            </thead>
            <tbody>
              {events.length === 0 ? (
                <tr><td colSpan={3} className="px-4 py-6 text-center text-gray-500">イベントがありません</td></tr>
              ) : (
                events.map(ev => (
                  <tr key={ev.id} className="border-t">
                    <td className="px-4 py-2 text-sm">{new Date(ev.created_at).toLocaleString()}</td>
                    <td className="px-4 py-2 text-sm">{ev.type}</td>
                    <td className="px-4 py-2 text-sm">{ev.id}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default UserLedgerPage;
